
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RepeaterService {
  private repeaters = new Map<string, any>(); // acepta cualquier tipo
  private addSubject = new Subject<void>();
  private addHandler?: () => void;
  private removeHandler?: () => void;

  constructor() {}

  setRepeater(key: string, ref: any): void {
    this.repeaters.set(key, ref);
  }

  registerAdd(handler: () => void) {
    this.addHandler = handler;
  }

  unregisterAdd(handler: () => void) {
    if (this.addHandler === handler) {
      this.addHandler = undefined;
    }
  }

  triggerAdd() {
      this.addHandler?.();
  }

  registerRemove(handler: () => void) {
    this.removeHandler = handler;
  }
 
  unregisterRemove(handler: () => void) {
    if (this.removeHandler === handler) {
      this.removeHandler = undefined;
    }
  }
 
triggerRemove() {
    this.removeHandler?.();
  }
 

  getRepeater<T = any>(key: string): T | undefined {
    return this.repeaters.get(key);
  }

  clearRepeater(key: string): void {
    this.repeaters.delete(key);
  }

  clearAll(): void {
    this.repeaters.clear();
  }
}
